export const REDUCER_NAME = 'detail'



// WEBPACK FOOTER //
// ./src/modules/store/state/detail/const.js